/* =========================================================================
 * Oasis land listing (sections/land-listing.liquid)
 * -------------------------------------------------------------------------
 * 1. Page behaviour: gallery, pop-ups, documents, videos, map, owner
 *    stories, section disclosures, reservation form, proposal quiz loader.
 * 2. Tracking, layered on the site-wide stack (nothing here replaces it):
 *    - Site-wide, unchanged: Viewed Lot, Scrolled Page, Started Reservation
 *      (cart/add submit), Submitted Form, Requested Info Pack, Played /
 *      Watched Lot Video, Opened FAQ Question, Reached Section, Played
 *      Review Video, Opened Concept Plans, Viewed Fixed Plan, dwell, taps.
 *    - Fired here with the legacy names (lead warehouse allow-listed):
 *      Browsed Gallery, Used Map.
 *    - New Klaviyo events (consent + identity gated by OasisTrack):
 *      Opened Reservation Details, Opened Proposal Request, Viewed Lot
 *      Document, Viewed Cost Breakdown (Requested Proposal: ppq script).
 *    - Every interaction: Microsoft Clarity event (ll_*), Shopify customer
 *      event (oasis_listing_*), dataLayer push, window 'oasis:listing'.
 *    - Engagement summary per page view (clicks, toggles, seconds per
 *      section, max scroll, gallery photos seen, video watch time) sent to
 *      the page-engagement warehouse, only with analytics consent.
 * ========================================================================= */
(function () {
  'use strict';

  var root = document.querySelector('[data-ll]');
  if (!root || root.__llReady) return;
  root.__llReady = true;

  function readJSON(id) {
    try { return JSON.parse(document.getElementById(id).textContent); } catch (e) { return {}; }
  }
  var CFG = readJSON('ll-config');
  var SOURCES = readJSON('ll-sources');
  var HANDLE = CFG.handle || root.getAttribute('data-product-handle') || '';

  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function byId(id) { return document.getElementById(id); }
  function clip(s, n) { return String(s == null ? '' : s).replace(/\s+/g, ' ').trim().slice(0, n); }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function withWidth(url, w) {
    if (!url) return '';
    var sized = new URL(url, document.baseURI);
    sized.searchParams.set('width', w);
    return sized.href;
  }

  /* =======================================================================
   * TRACKING
   * ===================================================================== */
  function sessionId() {
    try {
      var s = sessionStorage.getItem('oasis_idt_session');
      if (!s) {
        s = 'ss-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
        sessionStorage.setItem('oasis_idt_session', s);
      }
      return s;
    } catch (e) { return 'ss-volatile'; }
  }
  function base(props) {
    var p = { lot_handle: HANDLE, lot_name: CFG.title, island: CFG.island, path: location.pathname.slice(0, 200) };
    for (var k in (props || {})) if (props[k] !== undefined) p[k] = props[k];
    return p;
  }
  var trackingVersion = 'listing-v2';
  var trackingPageId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  var trackingSequence = 0, trackingPending = [], trackingDebug = null;
  if (new URLSearchParams(location.search).get('ll_tracking_debug') === '1') {
    trackingDebug = document.createElement('output');
    trackingDebug.id = 'll-tracking-status';
    trackingDebug.hidden = true;
    root.appendChild(trackingDebug);
  }
  function trackingAllowed(category) {
    try {
      if (navigator.globalPrivacyControl === true) return false;
      return !!(window.OasisConsent && window.OasisConsent.allowed(category));
    } catch (e) { return false; }
  }
  function trackingStatus(name, props) {
    if (!trackingDebug) return;
    var rows;
    try { rows = JSON.parse(trackingDebug.textContent || '[]'); } catch (e) { rows = []; }
    rows.push({ event: name, action: props.action || '', page_view_id: trackingPageId, sequence: props.sequence, status: 'passed_to_consent_gated_tracker' });
    trackingDebug.textContent = JSON.stringify(rows.slice(-150));
  }
  function drainTracking() {
    if (trackingDebug) {
      trackingDebug.setAttribute('data-marketing-consent', String(trackingAllowed('marketing')));
      trackingDebug.setAttribute('data-identified', String(!!(window.OasisTrack && window.OasisTrack.isIdentified && window.OasisTrack.isIdentified())));
    }
    if (!trackingAllowed('marketing')) { trackingPending.length = 0; return; }
    if (!window.OasisTrack || !window.OasisTrack.track) return;
    while (trackingPending.length) {
      var item = trackingPending.shift();
      window.OasisTrack.track(item.name, item.props);
      trackingStatus(item.name, item.props);
    }
  }
  function detailedTrack(name, props) {
    if (!trackingAllowed('marketing')) return;
    var p = base(props);
    p.tracking_version = trackingVersion;
    p.page_view_id = trackingPageId;
    p.sequence = ++trackingSequence;
    p.occurred_at = new Date().toISOString();
    p.__unique_id = trackingPageId + ':' + p.sequence;
    var theme = window.Shopify && window.Shopify.theme;
    p.theme_id = theme ? theme.id : null;
    p.theme_preview = theme && theme.role ? theme.role !== 'main' : new URLSearchParams(location.search).has('preview_theme_id');
    p.test_session = new URLSearchParams(location.search).get('ll_tracking_test') === '1';
    if (trackingPending.length >= 150) trackingPending.shift();
    trackingPending.push({ name: name, props: p });
    drainTracking();
  }
  setInterval(drainTracking, 1000);
  window.addEventListener('oasis:consent-updated', drainTracking);

  /* Klaviyo only (new event names are not on the warehouse allow-list). */
  function klaviyo(name, props, key) {
    var p = base(props);
    p.__unique_id = sessionId() + ':' + name + ':' + HANDLE + (key ? ':' + key : '');
    try { if (window.OasisTrack && window.OasisTrack.track) window.OasisTrack.track(name, p); } catch (e) {}
  }
  /* Legacy event names: Klaviyo + lead warehouse via the identity module. */
  function legacy(name, props, key) {
    var p = base(props);
    p.__unique_id = sessionId() + ':' + key + ':' + HANDLE;
    var tries = 0;
    (function send() {
      if (window.OasisIdentityTrack && window.OasisIdentityTrack.track) {
        try { window.OasisIdentityTrack.track(name, p); } catch (e) {}
      } else if (tries++ < 20) {
        setTimeout(send, 500);
      }
    })();
  }
  /* Analytics tools: Clarity, Shopify customer events, dataLayer. */
  function signal(action, detail) {
    var d = base(detail);
    d.action = action;
    detailedTrack('Listing Interaction', d);
    if (!trackingAllowed('analytics')) return;
    try { if (typeof window.clarity === 'function') window.clarity('event', 'll_' + action); } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('oasis_listing_' + action, d);
      }
    } catch (e) {}
    try { if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'oasis_listing_' + action, oasis: d }); } catch (e) {}
    try { window.dispatchEvent(new CustomEvent('oasis:listing', { detail: d })); } catch (e) {}
  }
  try { if (trackingAllowed('analytics') && typeof window.clarity === 'function') window.clarity('set', 'lot_handle', HANDLE); } catch (e) {}

  /* ---------- engagement summary (page-engagement warehouse) ---------- */
  var E = (function () {
    var endpoint = CFG.engage;
    var t0 = Date.now();
    var ua = navigator.userAgent || '';
    var S = {
      pv_id: (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 3 | 8)).toString(16);
      }),
      page: location.pathname,
      page_title: clip(document.title, 200),
      referrer: clip(document.referrer, 300),
      started_at: new Date().toISOString(),
      device: /iPad|Tablet/i.test(ua) ? 'tablet' : (/Mobi|Android|iPhone/i.test(ua) ? 'mobile' : 'desktop'),
      viewport: window.innerWidth + 'x' + window.innerHeight,
      utm: {},
      active_seconds: 0,
      max_scroll_pct: 0,
      sections: {},
      clicks: [],
      videos: {},
      toggles: []
    };
    try {
      var qs = new URLSearchParams(location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'fbclid', 'gclid'].forEach(function (k) {
        var v = qs.get(k); if (v) S.utm[k] = v.slice(0, 200);
      });
    } catch (e) {}
    var dirty = true, allowed = false, lastActive = Date.now(), current = null, playing = 0;
    function now() { return Math.round((Date.now() - t0) / 1000); }
    function chapterOf(node) {
      var c = node && node.closest ? node.closest('[data-chapter]') : null;
      if (c) return c.getAttribute('data-chapter');
      var d = node && node.closest ? node.closest('dialog, .ppq') : null;
      return d ? (d.id || 'dialog') : null;
    }
    function click(label, kind, node, href) {
      if (!trackingAllowed('analytics') || S.clicks.length >= 200) return;
      S.clicks.push({ label: clip(label, 80), kind: kind, section: chapterOf(node), href: href ? clip(String(href).split('?')[0], 200) : null, t: now() });
      dirty = true;
    }
    function toggle(label, node, open) {
      if (!trackingAllowed('analytics') || S.toggles.length >= 100) return;
      S.toggles.push({ label: clip(label, 80), section: chapterOf(node), open: !!open, t: now() });
      dirty = true;
    }
    function video(id, title, where) {
      var k = 'yt:' + id;
      return S.videos[k] || (S.videos[k] = { title: clip(title, 120), where: where, plays: 0, watched_s: 0, duration_s: 0, max_pct: 0, completed: false });
    }
    function setPlaying(n) { playing = n; }
    ['scroll', 'mousemove', 'keydown', 'touchstart', 'click'].forEach(function (ev) {
      window.addEventListener(ev, function () { lastActive = Date.now(); }, { passive: true, capture: true });
    });
    function chapterAtMiddle() {
      var mid = window.innerHeight / 2, list = document.querySelectorAll('[data-chapter]');
      for (var i = 0; i < list.length; i++) {
        var r = list[i].getBoundingClientRect();
        if (r.top <= mid && r.bottom >= mid && r.height > 0) return list[i].getAttribute('data-chapter');
      }
      return null;
    }
    function scrollPct() {
      var d = document.documentElement, h = Math.max(d.scrollHeight, document.body ? document.body.scrollHeight : 0);
      return h ? Math.min(100, Math.round((window.scrollY + window.innerHeight) / h * 100)) : 0;
    }
    var marks = [25, 50, 75, 90, 100], scrollQueued = false;
    window.addEventListener('scroll', function () {
      if (scrollQueued) return;
      scrollQueued = true;
      requestAnimationFrame(function () {
      scrollQueued = false;
      if (!trackingAllowed('analytics') && !trackingAllowed('marketing')) return;
      var p = scrollPct();
      if (p > S.max_scroll_pct) { S.max_scroll_pct = p; dirty = true; }
      while (marks.length && p >= marks[0]) signal('scroll_' + marks.shift(), {});
      });
    }, { passive: true });
    var tickers = [];
    setInterval(function () {
      if (!trackingAllowed('analytics') && !trackingAllowed('marketing')) return;
      if (document.visibilityState !== 'visible') return;
      if ((Date.now() - lastActive) >= 60000 && playing < 1) return;
      S.active_seconds++;
      var ch = document.querySelector('dialog[open]') ? null : chapterAtMiddle();
      if (ch) {
        var rec = S.sections[ch] || (S.sections[ch] = { seconds: 0, views: 0, first_s: now() });
        if (ch !== current) { rec.views++; current = ch; }
        rec.seconds++;
      }
      tickers.forEach(function (f) { try { f(); } catch (e) {} });
      if (S.active_seconds % 30 === 0) detailedTrack('Listing Active Time', { active_seconds: S.active_seconds, elapsed_seconds: now(), section_seconds: JSON.parse(JSON.stringify(S.sections)), max_scroll_pct: S.max_scroll_pct });
      dirty = true;
    }, 1000);
    function flush() {
      if (!endpoint || !allowed || !trackingAllowed('analytics') || !dirty) return;
      try { S.anon_id = localStorage.getItem('oasis_anonymous_id'); } catch (e) {}
      if (!S.anon_id) {
        S.anon_id = 'anon-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
        try { localStorage.setItem('oasis_anonymous_id', S.anon_id); } catch (e) {}
      }
      S.session_id = sessionId();
      var body = JSON.stringify(S);
      if (body.length > 45000) return;
      dirty = false;
      try {
        if (navigator.sendBeacon && navigator.sendBeacon(endpoint, new Blob([body], { type: 'text/plain' }))) return;
      } catch (e) {}
      try { fetch(endpoint, { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain' } }); } catch (e) { dirty = true; }
    }
    function consentOk() {
      return trackingAllowed('analytics');
    }
    function enable() { if (allowed) return; allowed = true; dirty = true; flush(); }
    if (window.OasisConsent && typeof window.OasisConsent.register === 'function') {
      window.OasisConsent.register('analytics', 'oasis-ll-engage', enable);
    }
    window.addEventListener('oasis:consent-updated', function () { if (consentOk()) enable(); else { allowed = false; S.clicks = []; S.toggles = []; S.sections = {}; S.active_seconds = 0; S.max_scroll_pct = 0; current = null; } });
    if (consentOk()) setTimeout(enable, 1500);
    setInterval(flush, 15000);
    var lastSummary = '';
    function summary(reason) {
      var signature = [S.active_seconds, S.max_scroll_pct, S.clicks.length, S.toggles.length].join(':');
      if (signature === lastSummary || !trackingAllowed('marketing')) return;
      lastSummary = signature;
      detailedTrack('Listing Engagement Summary', { reason: reason, active_seconds: S.active_seconds, elapsed_seconds: now(), max_scroll_pct: S.max_scroll_pct, sections: JSON.parse(JSON.stringify(S.sections)), clicks: S.clicks.slice(), toggles: S.toggles.slice(), videos: JSON.parse(JSON.stringify(S.videos)) });
    }
    setInterval(function () { summary('interval'); }, 60000);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') { summary('hidden'); flush(); } });
    window.addEventListener('pagehide', function () { summary('pagehide'); flush(); });
    return { state: S, click: click, toggle: toggle, video: video, tick: function (f) { tickers.push(f); }, playing: setPlaying, flush: function () { dirty = true; flush(); } };
  })();
  window.OasisListingEngage = E;

  /* Every link, button and summary in the listing (and its pop-ups). */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('a,button,summary,label,[data-cta]') : null;
    if (!t || !(root.contains(t))) return;
    var label = t.getAttribute('data-cta') || t.getAttribute('aria-label') || t.textContent || t.value;
    var kind = t.getAttribute('data-cta') ? 'cta' : t.tagName.toLowerCase();
    E.click(label, kind, t, t.getAttribute('href'));
    detailedTrack('Clicked Listing Control', { control: clip(label, 100), kind: kind, control_id: t.id || '', section: (t.closest('[data-chapter]') || {}).id || '', destination: t.getAttribute('href') ? String(t.getAttribute('href')).split('?')[0].split('#')[0] : '' });
    if (t.getAttribute('data-cta')) signal('cta', { cta: t.getAttribute('data-cta') });
  }, true);

  /* Every collapsible, including sections, question groups, questions and steps. */
  root.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS') return;
    var sum = d.querySelector('summary');
    var label = d.id || (sum ? sum.textContent : '');
    if (sum) {
      var t = sum.querySelector('.fold-title, .qa-group-title, .purchase-step-title, span');
      label = (d.id ? d.id + ': ' : '') + clip(t ? t.textContent : sum.textContent, 60);
    }
    E.toggle(label, d, d.open);
    detailedTrack('Toggled Listing Section', { section: d.id || '', label: clip(label, 100), open: !!d.open });
    if (!d.open) return;
    if (d.classList.contains('section-disclosure')) signal('section_open', { section: (d.closest('section') || {}).id });
    else if (d.classList.contains('faq-details')) signal('faq_open', { question: clip(sum && sum.textContent, 90) });
    else if (d.classList.contains('qa-group')) signal('faq_group_open', { group: d.id });
    else if (d.classList.contains('purchase-step')) signal('step_open', { step: d.id });
    else signal('detail_open', { detail: clip(label, 60) });
  }, true);

  /* Sections seen (once each). */
  if ('IntersectionObserver' in window) {
    var seen = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        seen.unobserve(en.target);
        signal('section_view', { section: en.target.getAttribute('data-chapter') });
      });
    }, { threshold: 0.2 });
    $$('[data-chapter]').forEach(function (s) { seen.observe(s); });
  }

  /* =======================================================================
   * PAGE BEHAVIOUR
   * ===================================================================== */
  var toastTimer;
  function toast(msg) {
    var t = byId('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('visible'); }, 3200);
  }

  /* ---------- pop-ups ---------- */
  var lastTrigger = null;
  var DIALOG_EVENTS = {
    reserve: function (t) {
      klaviyo('Opened Reservation Details', { source: t && t.getAttribute('data-cta') }, 'reserve');
      try { if (typeof window.clarity === 'function') window.clarity('set', 'll_reserve_opened', 'yes'); } catch (e) {}
    },
    costs: function () { klaviyo('Viewed Cost Breakdown', {}, 'costs'); },
    zoning: function () { klaviyo('Viewed Zoning Guidelines', {}, 'zoning'); },
    map: function () { legacy('Used Map', { how: 'opened' }, 'map'); }
  };
  function openDialog(key, trigger) {
    var modal = byId('modal-' + key);
    if (!modal || typeof modal.showModal !== 'function') return;
    lastTrigger = trigger || document.activeElement;
    if (!modal.open) modal.showModal();
    document.documentElement.classList.add('ll-lock');
    if (key === 'zoning') {
      var zbox = byId('zoning-container'), zfb = byId('zoning-fallback');
      /* Phones and browsers without a built-in PDF viewer get a clear "Open the PDF" instead of a blank frame. */
      var inline = navigator.pdfViewerEnabled !== false && !(window.matchMedia && matchMedia('(max-width: 800px)').matches);
      if (zbox && inline && !zbox.querySelector('iframe')) {
        var zf = document.createElement('iframe');
        zf.title = 'Zoning guidelines (PDF)';
        zf.src = modal.getAttribute('data-pdf') + '#view=FitH';
        zbox.replaceChildren(zf);
      }
      if (zbox) zbox.hidden = !inline;
      if (zfb) zfb.hidden = inline;
    }
    if (key === 'map') {
      var box = byId('map-container');
      if (box && !box.querySelector('iframe')) {
        var f = document.createElement('iframe');
        f.className = 'map-frame';
        f.title = 'Interactive map of ' + CFG.title;
        f.src = modal.getAttribute('data-map-src');
        f.loading = 'lazy';
        box.replaceChildren(f);
      }
    }
    E.click('open: ' + key, 'dialog', trigger || modal);
    signal('dialog_open', { dialog: key, source: trigger && trigger.getAttribute ? trigger.getAttribute('data-cta') : null });
    if (DIALOG_EVENTS[key]) DIALOG_EVENTS[key](trigger);
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-dialog]');
    if (!b) return;
    e.preventDefault();
    openDialog(b.getAttribute('data-dialog'), b);
  });
  $$('dialog').forEach(function (d) {
    var c = d.querySelector('[data-close]');
    if (c) c.addEventListener('click', function () { d.close(); });
    d.addEventListener('click', function (e) {
      if (e.target !== d) return;
      var r = d.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
    });
    d.addEventListener('close', function () {
      if (!document.querySelector('dialog[open]')) document.documentElement.classList.remove('ll-lock');
      if (d.id === 'modal-video' || d.id === 'modal-gallery') stopVideo();
      if (lastTrigger && lastTrigger.focus) { try { lastTrigger.focus({ preventScroll: true }); } catch (e) {} }
      E.click('close: ' + d.id.replace('modal-', ''), 'dialog', d);
    });
  });

  /* ---------- gallery ---------- */
  function galleryImageName(src) {
    if (!src) return '';
    try {
      var filename = new URL(src, location.href).pathname.split('/').pop();
      try { filename = decodeURIComponent(filename); } catch (e) {}
      return filename.replace(/\.(avif|gif|jpe?g|png|svg|webp)$/i, '').replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
    } catch (e) { return ''; }
  }
  function updateImageName(item) {
    var label = byId('hero-image-name');
    if (!label) return;
    var name = item && !item.video ? galleryImageName(item.img) : '';
    label.textContent = name;
    label.title = name;
    label.hidden = !name;
  }

  var thumbs = $$('[data-hero]');
  var gallery = thumbs.map(function (b) {
    return {
      img: b.getAttribute('data-img'),
      video: b.getAttribute('data-video-id') || '',
      videoKind: b.getAttribute('data-video-kind') || 'youtube',
      videoTemplate: b.getAttribute('data-video-template') || '',
      ratio: Number(b.getAttribute('data-ratio')) || 0,
      caption: b.getAttribute('data-caption') || '',
      alt: b.getAttribute('data-alt') || '',
      note: b.getAttribute('data-note') || '',
      chapter: b.getAttribute('data-group') || ''
    };
  });
  var heroCount = gallery.length;
  if (heroCount) updateImageName(gallery[0]);
  $$('[data-lifestyle-photo]').forEach(function (b) {
    b.setAttribute('data-gallery', String(gallery.length));
    gallery.push({ img: b.getAttribute('data-img'), caption: b.getAttribute('data-caption') || '', alt: b.getAttribute('data-caption') || '', note: '', chapter: 'island-life' });
  });
  function showVideoPoster(host, item) {
    host.replaceChildren();
    var button = document.createElement('button');
    button.type = 'button'; button.className = 'listing-inline-play';
    button.setAttribute('aria-label', 'Play ' + item.caption);
    var poster = new Image(); poster.src = item.img; poster.alt = ''; poster.width = 1280; poster.height = 720;
    var label = document.createElement('span'); label.textContent = '▶  Play video';
    button.append(poster, label); host.append(button);
    button.addEventListener('click', function () {
      if (item.videoKind === 'native') { playNativeVideo(host, item); return; }
      if (item.videoKind === 'vimeo') {
        stopVideo(); activeVideoHost = host;
        var frame = document.createElement('iframe');
        frame.src = 'https://player.vimeo.com/video/' + encodeURIComponent(item.video) + '?autoplay=1&playsinline=1';
        frame.title = item.caption; frame.allow = 'autoplay; fullscreen; picture-in-picture'; frame.allowFullscreen = true;
        host.replaceChildren(frame);
        signal('video_open', { video: item.video, where: 'gallery-slide', provider: 'vimeo' });
        return;
      }
      playVideo('https://www.youtube-nocookie.com/embed/' + encodeURIComponent(item.video), item.video, item.caption, 'gallery-slide', button, 'https://www.youtube.com/watch?v=' + item.video, host);
    });
  }
  function playNativeVideo(host, item) {
    stopVideo();
    var template = document.getElementById(item.videoTemplate);
    if (!template) { toast('This video is not ready yet. Please try again later.'); return; }
    host.replaceChildren(template.content.cloneNode(true));
    var video = host.querySelector('video');
    if (!video) return;
    activeVideoHost = host;
    video.controls = true; video.playsInline = true; video.preload = 'metadata';
    var rec = E.video(String(item.video), item.caption, 'gallery-slide');
    var entry = { id: String(item.video), rec: rec, state: -1 }; activeEntry = entry;
    activePlayer = { getDuration: function () { return video.duration; }, getCurrentTime: function () { return video.currentTime; }, destroy: function () { video.pause(); video.remove(); } };
    video.addEventListener('play', function () { if (activeEntry !== entry) return; entry.state = 1; E.playing(1); signal('video_play', { video: item.video }); });
    video.addEventListener('pause', function () { if (activeEntry !== entry) return; entry.state = 2; E.playing(0); E.flush(); });
    video.addEventListener('ended', function () { rec.completed = true; rec.max_pct = 100; signal('video_complete', { video: item.video }); E.flush(); });
    rec.plays++; signal('video_open', { video: item.video, where: 'gallery-slide', provider: 'shopify' });
    video.play().catch(function () {});
  }
  var heroIndex = 0, heroWanted = 0, galleryIndex = 0;
  var heroRequest = 0, lightboxRequest = 0, photoCache = {};
  var heroElement = byId('hero-image');
  var photoWidths = [480, 720, 960, 1200, 1440, 1800];
  var photoSizes = heroElement ? heroElement.sizes : '100vw';
  function photoSet(item) {
    return photoWidths.map(function (w) { return withWidth(item.img, w) + ' ' + w + 'w'; }).join(', ');
  }
  function preparePhoto(index, fullscreen, priority) {
    var item = gallery[index], width = 0;
    if (fullscreen) {
      var ratio = item.ratio || 1.5;
      var displayWidth = Math.min(window.innerWidth - 32, (window.innerHeight - 120) * ratio);
      var target = displayWidth * Math.min(window.devicePixelRatio || 1, 2);
      width = [720, 960, 1200, 1440, 1800, 2000].filter(function (w) { return w >= target; })[0] || 2000;
    }
    var key = index + ':' + (fullscreen ? width : Math.round(window.innerWidth));
    if (photoCache[key]) {
      if (priority === 'high') photoCache[key].image.fetchPriority = 'high';
      return photoCache[key].ready;
    }
    var photo = new Image();
    photo.decoding = 'async';
    photo.fetchPriority = priority || 'low';
    var ready = new Promise(function (resolve, reject) {
      photo.onload = function () {
        if (!item.ratio) item.ratio = photo.naturalWidth / photo.naturalHeight;
        var decoded = photo.decode ? photo.decode().catch(function () {}) : Promise.resolve();
        decoded.then(function () { resolve(photo); });
      };
      photo.onerror = function () { delete photoCache[key]; reject(new Error('Photo unavailable')); };
    });
    photoCache[key] = { image: photo, ready: ready };
    if (!fullscreen) { photo.sizes = photoSizes; photo.srcset = photoSet(item); }
    photo.src = withWidth(item.img, width || 1200);
    return ready;
  }
  function warmNeighbours(index, fullscreen) {
    var connection = navigator.connection;
    var count = fullscreen ? gallery.length : heroCount;
    if (count < 2 || document.hidden || (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType)))) return;
    [1, -1].forEach(function (step) {
      var n = (index + step + count) % count;
      if (gallery[n].video) return;
      preparePhoto(n, fullscreen, 'low').catch(function () {});
    });
  }
  function startGalleryWarmup() {
    if ('requestIdleCallback' in window) requestIdleCallback(function () { warmNeighbours(0, false); }, { timeout: 1200 });
    else setTimeout(function () { warmNeighbours(0, false); }, 200);
  }
  if (heroElement) {
    if (heroElement.complete) startGalleryWarmup();
    else heroElement.addEventListener('load', startGalleryWarmup, { once: true });
  }
  var photosSeen = {}, photosSeenCount = 0, galleryActions = 0;
  function notePhoto(i, how) {
    galleryActions++;
    if (galleryActions === 3) legacy('Browsed Gallery', { interactions: 3 }, 'gal');
    if (photosSeen[i]) return;
    photosSeen[i] = 1;
    photosSeenCount++;
    var item = gallery[i] || {};
    E.click('photo ' + pad2(i + 1) + ': ' + item.caption, 'gallery', byId('hero-open'));
    signal('gallery_view', { photo: i + 1, how: how, chapter: item.chapter });
    var total = gallery.length;
    if (total >= 3 && photosSeenCount === Math.max(3, Math.ceil(total * 0.6))) {
      legacy('Browsed Gallery', { slides_viewed: photosSeenCount, slides_total: total, depth: 'most' }, 'gallery-deep');
    }
    if (total > 1 && photosSeenCount === total) signal('gallery_complete', { photos: total });
  }
  photosSeen[0] = 1; photosSeenCount = 1;

  function renderHero(i, how) {
    if (!heroCount) return;
    heroWanted = (i + heroCount) % heroCount;
    var requested = heroWanted, request = ++heroRequest;
    var opener = byId('hero-open'), host = byId('hero-video');
    var item = gallery[requested];
    stopVideo();
    function update() {
      heroIndex = requested;
      updateImageName(item);
      opener.hidden = !!item.video; host.hidden = !item.video;
      byId('hero-expand').hidden = !!item.video;
      opener.parentElement.style.setProperty('--gallery-ratio', item.ratio || 1.5);
      if (item.video) showVideoPoster(host, item);
      else host.replaceChildren();
      opener.removeAttribute('aria-busy');
      var counter = byId('hero-counter');
      if (counter) counter.textContent = pad2(heroIndex + 1) + ' / ' + pad2(heroCount);
      byId('hero-caption').textContent = item.caption;
      byId('hero-note').textContent = item.note || '';
      opener.setAttribute('data-gallery', String(heroIndex));
      opener.setAttribute('aria-label', 'Enlarge photograph: ' + item.caption);
      byId('hero-expand').setAttribute('data-gallery', String(heroIndex));
      thumbs.forEach(function (b, n) { b.setAttribute('aria-pressed', String(n === heroIndex)); });
      var sel = thumbs[heroIndex], strip = sel && sel.parentElement;
      if (strip) strip.scrollTo({ left: sel.offsetLeft - strip.offsetLeft - (strip.clientWidth - sel.clientWidth) / 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      notePhoto(heroIndex, how || 'thumb'); warmNeighbours(heroIndex, false);
    }
    if (item.video) { update(); return; }
    var busyTimer = setTimeout(function () { if (request === heroRequest) opener.setAttribute('aria-busy', 'true'); }, 150);
    preparePhoto(requested, false, 'high').then(function (photo) {
      clearTimeout(busyTimer); if (request !== heroRequest) return;
      var img = byId('hero-image');
      img.sizes = photoSizes; img.srcset = photo.srcset; img.src = photo.src; img.alt = item.alt;
      img.width = photo.naturalWidth; img.height = photo.naturalHeight;
      update();
    }, function () {
      clearTimeout(busyTimer); if (request !== heroRequest) return;
      heroWanted = heroIndex; opener.removeAttribute('aria-busy');
      toast('This photo could not load. Please try again.');
    });
  }
  thumbs.forEach(function (b, n) {
    b.addEventListener('click', function () { renderHero(n, 'thumb'); });
    b.addEventListener('keydown', function (e) {
      var next = n;
      if (e.key === 'ArrowRight') next = (n + 1) % heroCount;
      else if (e.key === 'ArrowLeft') next = (n - 1 + heroCount) % heroCount;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = heroCount - 1;
      else return;
      e.preventDefault();
      renderHero(next, 'keyboard');
      thumbs[next].focus();
    });
  });
  var prev = byId('hero-prev'), next = byId('hero-next');
  if (prev) prev.addEventListener('click', function () { renderHero(heroWanted - 1, 'arrow'); });
  if (next) next.addEventListener('click', function () { renderHero(heroWanted + 1, 'arrow'); });
  $$('[data-gallery-chapter]').forEach(function (b) {
    b.addEventListener('click', function () {
      var ch = b.getAttribute('data-gallery-chapter');
      for (var i = 0; i < heroCount; i++) if (gallery[i].chapter === ch) { renderHero(i, 'chapter'); break; }
    });
  });
  var heroPhoto = root.querySelector('.listing-gallery-stage'), heroTouch = null, ignoreClickUntil = 0;
  if (heroPhoto) {
    heroPhoto.addEventListener('touchstart', function (e) { var t = e.touches[0]; heroTouch = { x: t.clientX, y: t.clientY }; }, { passive: true });
    heroPhoto.addEventListener('touchend', function (e) {
      if (!heroTouch) return;
      var t = e.changedTouches[0], dx = t.clientX - heroTouch.x, dy = t.clientY - heroTouch.y;
      heroTouch = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { renderHero(heroWanted + (dx < 0 ? 1 : -1), 'swipe'); ignoreClickUntil = Date.now() + 500; }
    }, { passive: true });
    heroPhoto.addEventListener('touchcancel', function () { heroTouch = null; }, { passive: true });
    heroPhoto.addEventListener('click', function (e) { if (Date.now() < ignoreClickUntil) { e.preventDefault(); e.stopImmediatePropagation(); } }, true);
  }
  /* Scrolling the thumbnail strip is its own signal. */
  var strip = byId('hero-thumbs'), stripScrolled = false, stripFrom = 0;
  if (strip) {
    strip.addEventListener('scroll', function () {
      if (stripScrolled || Math.abs(strip.scrollLeft - stripFrom) < 60) return;
      stripScrolled = true;
      E.click('gallery thumbnails scrolled', 'scroll', strip);
      signal('gallery_scrolled', {});
    }, { passive: true });
  }

  function showImage(i, how) {
    if (!gallery.length) return;
    galleryIndex = (i + gallery.length) % gallery.length;
    var item = gallery[galleryIndex];
    var im = byId('gallery-image');
    var requested = galleryIndex, request = ++lightboxRequest;
    stopVideo();
    var videoHost = byId('gallery-video');
    im.hidden = !!item.video; videoHost.hidden = !item.video;
    videoHost.replaceChildren();
    if (item.video) {
      showVideoPoster(videoHost, item);
      byId('gallery-caption').textContent = (requested + 1) + ' / ' + gallery.length + ' · ' + item.caption;
      notePhoto(requested, how || 'lightbox'); return;
    }
    if (how === 'open' && heroElement) { im.src = heroElement.currentSrc || heroElement.src; im.alt = item.alt; }
    preparePhoto(requested, true, 'high').then(function (photo) {
      if (request !== lightboxRequest) return;
      im.src = photo.src;
      im.alt = item.alt;
      var c = byId('gallery-caption');
      c.replaceChildren(document.createTextNode((requested + 1) + ' / ' + gallery.length + ' · ' + item.caption));
      if (item.note) c.append(el('small', null, item.note));
      notePhoto(requested, how || 'lightbox');
      warmNeighbours(requested, true);
    }, function () { if (request === lightboxRequest) toast('This photo could not load. Please try again.'); });
    if (how === 'open') byId('gallery-caption').textContent = (requested + 1) + ' / ' + gallery.length + ' · ' + item.caption;
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gallery]');
    if (!b) return;
    showImage(Number(b.getAttribute('data-gallery')) || 0, 'open');
    openDialog('gallery', b);
    signal('gallery_fullscreen', {});
  });
  if (byId('gallery-prev')) byId('gallery-prev').addEventListener('click', function () { showImage(galleryIndex - 1, 'lightbox'); });
  if (byId('gallery-next')) byId('gallery-next').addEventListener('click', function () { showImage(galleryIndex + 1, 'lightbox'); });
  if (byId('modal-gallery')) byId('modal-gallery').addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { e.preventDefault(); showImage(galleryIndex + 1, 'keyboard'); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); showImage(galleryIndex - 1, 'keyboard'); }
  });
  var touchBox = byId('gallery-touch'), touchX = null;
  if (touchBox) {
    touchBox.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    touchBox.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 45) showImage(galleryIndex + (dx < 0 ? 1 : -1), 'swipe');
      touchX = null;
    }, { passive: true });
  }

  if (heroCount && gallery[0].video) requestAnimationFrame(function () { renderHero(0, 'initial'); });

  /* ---------- documents ---------- */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-document]');
    if (!b) return;
    var key = b.getAttribute('data-document'), doc = (CFG.docs || {})[key];
    if (!doc) return;
    var title = b.getAttribute('data-document-title') || 'Document';
    byId('document-title').textContent = title;
    var planNotice = byId('document-plan-notice');
    if (planNotice) planNotice.hidden = key !== 'parcel-map';
    var im = byId('document-image');
    im.src = doc.img; im.alt = title;
    byId('modal-document').classList.remove('document-expanded');
    byId('document-enlarge').setAttribute('aria-pressed', 'false');
    byId('document-enlarge').textContent = 'Open full size';
    openDialog('document', b);
    klaviyo('Viewed Lot Document', { document: key }, 'doc-' + key);
    signal('document_open', { document: key });
  });

  byId('document-enlarge').addEventListener('click', function () {
    var expanded = byId('modal-document').classList.toggle('document-expanded');
    this.setAttribute('aria-pressed', String(expanded));
    this.textContent = expanded ? 'Fit to window' : 'Open full size';
  });

  /* ---------- sources ---------- */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-src-key]');
    if (!b) return;
    var key = b.getAttribute('data-src-key'), info = SOURCES[key];
    if (!info) return;
    var body = byId('source-body');
    body.replaceChildren(el('span', 'eyebrow', 'Source'), el('h3', 'source-title', info.title), el('p', 'source-meta', info.meta), el('p', 'source-lead', 'What it says'));
    var ul = el('ul', 'reserve-points');
    (info.points || []).forEach(function (p) { ul.append(el('li', null, p)); });
    body.append(ul);
    var more = el('p', 'fine-print popup-more'), a = el('a', null, 'Read the original on ' + info.site + ' ');
    a.insertAdjacentHTML('beforeend', '<svg class="ll-icon ext-arrow" aria-hidden="true"><use href="#lli-arrow"/></svg>');
    a.href = info.url; a.target = '_blank'; a.rel = 'noopener';
    more.append(a);
    body.append(more);
    openDialog('source', b);
    signal('source_open', { source: key });
  });

  /* ---------- videos (tracked with the YouTube player API) ---------- */
  var ytQueue = [], ytLoading = false, activePlayer = null, activeEntry = null, activeVideoHost = null;
  function withYT(fn) {
    if (window.YT && window.YT.Player) { fn(); return; }
    ytQueue.push(fn);
    if (ytLoading) return;
    ytLoading = true;
    var prevReady = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof prevReady === 'function') { try { prevReady(); } catch (e) {} }
      var q = ytQueue; ytQueue = [];
      q.forEach(function (f) { try { f(); } catch (e) {} });
    };
    if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
      var s = document.createElement('script');
      s.src = 'https://www.youtube.com/iframe_api';
      s.async = true;
      document.head.appendChild(s);
    }
  }
  E.tick(function () {
    if (!activeEntry || activeEntry.state !== 1 || !activePlayer) return;
    var rec = activeEntry.rec;
    rec.watched_s++;
    try {
      var d = activePlayer.getDuration(), c = activePlayer.getCurrentTime();
      if (d > 0) {
        rec.duration_s = Math.round(d);
        var pct = Math.round(c / d * 100);
        if (pct > rec.max_pct) {
          [25, 50, 75, 90].forEach(function (m) { if (rec.max_pct < m && pct >= m) signal('video_' + m, { video: activeEntry.id }); });
          rec.max_pct = Math.min(100, pct);
        }
        if (pct >= 95) rec.completed = true;
      }
    } catch (e) {}
  });
  function playVideo(src, id, title, where, trigger, externalUrl, inlineHost) {
    stopVideo();
    byId('video-title').textContent = title;
    var f = document.createElement('iframe');
    f.id = 'll-yt-' + Date.now().toString(36);
    f.className = 'media-frame';
    f.title = title;
    f.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1&rel=0&playsinline=1&enablejsapi=1&origin=' + encodeURIComponent(location.origin);
    f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
    f.allowFullscreen = true;
    f.referrerPolicy = 'strict-origin-when-cross-origin';
    activeVideoHost = inlineHost || byId('video-container');
    activeVideoHost.replaceChildren(f);
    if (byId('video-external')) byId('video-external').href = externalUrl;
    if (!inlineHost) openDialog('video', trigger);
    var rec = E.video(id, title, where);
    rec.plays++;
    activeEntry = { id: id, rec: rec, state: -1 };
    signal('video_open', { video: id, where: where });
    withYT(function () {
      if (!document.getElementById(f.id)) return;
      var entry = activeEntry;
      try {
        activePlayer = new window.YT.Player(f.id, {
          events: {
            onStateChange: function (ev) {
              if (!entry || entry !== activeEntry) return;
              entry.state = ev.data;
              E.playing(ev.data === 1 ? 1 : 0);
              if (ev.data === 1) signal('video_play', { video: id });
              if (ev.data === 0) { entry.rec.completed = true; entry.rec.max_pct = 100; signal('video_complete', { video: id }); E.flush(); }
            }
          }
        });
      } catch (e) {}
    });
  }
  function stopVideo() {
    E.playing(0);
    if (activeEntry) activeEntry.state = 2;
    try { if (activePlayer && activePlayer.destroy) activePlayer.destroy(); } catch (e) {}
    activePlayer = null; activeEntry = null;
    if (activeVideoHost) activeVideoHost.replaceChildren();
    activeVideoHost = null;
    byId('video-container').replaceChildren();
    E.flush();
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-video]');
    if (b) {
      var id = b.getAttribute('data-video');
      if (!id) return;
      var where = b.closest('#stories, #owners') ? 'owners' : b.closest('#team') ? 'welcome' : (b.closest('#location, #island-life') ? 'island' : 'listing');
      var videoParams = new URLSearchParams();
      if (b.hasAttribute('data-captions')) { videoParams.set('cc_load_policy', '1'); videoParams.set('cc_lang_pref', 'en'); }
      var start = Math.max(0, parseInt(b.getAttribute('data-video-start'), 10) || 0);
      if (start) videoParams.set('start', String(start));
      var videoQuery = videoParams.toString();
      playVideo('https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + (videoQuery ? '?' + videoQuery : ''), id, b.getAttribute('data-video-title') || 'Oasis film', where, b, 'https://www.youtube.com/watch?v=' + id + (start ? '&t=' + start + 's' : ''));
      return;
    }
    var l = e.target.closest('[data-video-list]');
    if (l) {
      var list = l.getAttribute('data-video-list');
      playVideo('https://www.youtube-nocookie.com/embed/videoseries?list=' + encodeURIComponent(list), 'list-' + list.slice(-8), l.getAttribute('data-video-title') || 'Oasis films', 'owners-playlist', l, 'https://www.youtube.com/playlist?list=' + list);
    }
  });

  /* booking pop-up opened from inside a pop-up: close ours first so the booking form sits on top */
  root.addEventListener('click', function (e) {
    var om = e.target.closest && e.target.closest('[data-open-modal]');
    if (!om) return;
    var dlg = om.closest('dialog[open]');
    if (dlg) dlg.close();
    if (om.closest('#ppq') && window.OasisPPQ) window.OasisPPQ.close();
  });

  /* ---------- owner stories ---------- */
  var storyButtons = $$('[data-owner-story]');
  function selectStory(i) {
    var b = storyButtons[i];
    if (!b) return;
    var play = byId('owner-story-play'), img = byId('owner-story-image');
    var id = b.getAttribute('data-video-id'), title = b.getAttribute('data-title');
    img.src = b.getAttribute('data-img');
    img.alt = b.getAttribute('data-alt');
    play.setAttribute('data-video', id);
    play.setAttribute('data-video-id', id);
    play.setAttribute('data-video-title', title);
    play.setAttribute('aria-label', 'Play video: ' + title);
    byId('owner-story-topic').textContent = b.getAttribute('data-topic');
    byId('owner-story-count').textContent = pad2(i + 1) + ' / ' + pad2(storyButtons.length);
    byId('owner-story-title').textContent = title;
    storyButtons.forEach(function (x, n) { x.setAttribute('aria-pressed', String(n === i)); });
    signal('owner_story_selected', { video: id });
  }
  storyButtons.forEach(function (b, n) {
    b.addEventListener('click', function () { selectStory(n); });
    b.addEventListener('keydown', function (e) {
      var k = e.key, m = n, len = storyButtons.length;
      if (k === 'ArrowDown' || k === 'ArrowRight') m = (n + 1) % len;
      else if (k === 'ArrowUp' || k === 'ArrowLeft') m = (n + len - 1) % len;
      else if (k === 'Home') m = 0;
      else if (k === 'End') m = len - 1;
      else return;
      e.preventDefault();
      selectStory(m);
      storyButtons[m].focus();
    });
  });

  /* ---------- other lots: preview before leaving the page ---------- */
  root.addEventListener('click', function (e) {
    var card = e.target.closest('[data-lot-preview]');
    if (!card) return;
    e.preventDefault();
    var box = byId('lot-preview'), name = card.querySelector('h3').textContent.trim();
    box.replaceChildren();
    var img = card.querySelector('img');
    if (img) { var c = img.cloneNode(); c.removeAttribute('loading'); c.className = 'lot-preview-img'; box.append(c); }
    box.append(el('span', 'eyebrow', card.querySelector('.story-kind').textContent), el('h3', null, name), el('p', null, card.querySelector('p').textContent));
    var price = card.querySelector('.nearby-price');
    if (price) {
      var pr = el('p', 'lot-preview-price');
      pr.append(el('strong', null, price.firstChild.textContent.trim()), el('small', null, ' USD land price'));
      box.append(pr);
    }
    box.append(el('p', 'fine-print', 'Current listed price. Check the listing for availability and terms.'));
    var go = el('a', 'll-btn full', 'View ' + name);
    go.href = card.getAttribute('href');
    go.setAttribute('data-cta', 'nearby-view');
    box.append(go);
    byId('lot-title').textContent = name;
    openDialog('lot', card);
    signal('nearby_preview', { lot: card.getAttribute('data-handle') });
  });

  /* ---------- share ---------- */
  var share = byId('ll-share');
  if (share) share.addEventListener('click', function () {
    var url = CFG.url || location.href.split('?')[0];
    signal('share', {});
    if (navigator.share) {
      navigator.share({ title: CFG.title + ' | Oasis Land', url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () { toast('Listing link copied.'); }, function () { toast(url); });
    } else {
      toast(url);
    }
  });

  /* ---------- reservation ---------- */
  var reserveForm = $('[data-ll-reserve]');
  if (reserveForm) {
    var accept = reserveForm.querySelector('[data-ll-accept]'), pay = reserveForm.querySelector('[data-ll-pay]');
    accept.addEventListener('change', function () {
      pay.disabled = !accept.checked;
      if (accept.checked) signal('reserve_terms_accepted', {});
    });
    reserveForm.addEventListener('submit', function (e) {
      if (!accept.checked) { e.preventDefault(); accept.focus(); return; }
      reserveForm.querySelector('[data-ll-terms-stamp]').value = 'Accepted ' + new Date().toISOString();
      signal('reserve_submit', { monthly: CFG.monthly });
      try { if (typeof window.clarity === 'function') window.clarity('set', 'll_reserve_submitted', 'yes'); } catch (e2) {}
      E.flush();
      setTimeout(function () { pay.disabled = true; }, 0);
    });
  }

  root.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-concepts-chat]');
    if (!trigger) return;
    e.preventDefault();
    function openConceptChat() {
      var widget = document.querySelector('oasis-chat-widget');
      if (!widget || typeof widget.setOpen !== 'function') return false;
      widget.setOpen(true);
      if (widget.input && !widget.input.value.trim() && !widget.ended) {
        widget.input.value = "I'd like to know more about the concept designs for " + CFG.title + ".";
        widget.input.dispatchEvent(new Event('input', { bubbles: true }));
      }
      signal('concepts_chat_open', { lot: CFG.title });
      return true;
    }
    if (openConceptChat()) return;
    trigger.disabled = true;
    var ready = window.customElements ? customElements.whenDefined('oasis-chat-widget') : Promise.resolve();
    Promise.race([ready, new Promise(function (resolve) { setTimeout(resolve, 5000); })]).then(function () {
      trigger.disabled = false;
      if (!openConceptChat()) toast('Chat is unavailable right now. Please request a personal proposal and include your concept-design questions.');
    });
  });

  /* ---------- back to top ---------- */
  var topBtn = byId('ll-top');
  if (topBtn) {
    var topShown = false;
    var syncTop = function () {
      var show = window.scrollY > Math.min(400, window.innerHeight * 0.5);
      if (show !== topShown) { topShown = show; topBtn.hidden = !show; }
    };
    window.addEventListener('scroll', syncTop, { passive: true });
    syncTop();
    topBtn.addEventListener('click', function () {
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      signal('back_to_top', { from_pct: Math.round((window.scrollY + window.innerHeight) / document.documentElement.scrollHeight * 100) });
      var h = root.querySelector('h1');
      if (h) { h.setAttribute('tabindex', '-1'); try { h.focus({ preventScroll: true }); } catch (e) {} }
    });
  }

  /* ---------- personal proposal: script loads on first use ---------- */
  var ppq = byId('ppq'), ppqLoading = null;
  function loadPPQ() {
    if (window.OasisPPQ) return Promise.resolve();
    if (ppqLoading) return ppqLoading;
    ppqLoading = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = ppq.getAttribute('data-script');
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return ppqLoading;
  }
  if (ppq) {
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-ppq-open]') : null;
      if (!t) return;
      e.preventDefault();
      var dlg = t.closest('dialog');
      if (dlg) dlg.close();
      klaviyo('Opened Proposal Request', { source: t.getAttribute('data-cta') }, 'ppq');
      signal('proposal_open', { source: t.getAttribute('data-cta') });
      loadPPQ().then(function () { window.OasisPPQ.open(t); }, function () {
        toast('Please call ' + (ppq.getAttribute('data-phone') || 'us') + ' and we’ll prepare your proposal.');
      });
    });
    var warm = function () { loadPPQ().catch(function () {}); };
    $$('[data-ppq-open]').forEach(function (trigger) {
      trigger.addEventListener('pointerenter', warm, { once: true });
      trigger.addEventListener('focus', warm, { once: true });
      trigger.addEventListener('touchstart', warm, { once: true, passive: true });
    });
  }
  window.OasisListing = { signal: signal, klaviyo: klaviyo, track: detailedTrack, engage: E, config: CFG };

  /* ---------- sub-navigation and section disclosures ---------- */
  var navLinks = $$('.subnav a'), ticking = false;
  function updateNav() {
    var active = 'land';
    navLinks.forEach(function (a) {
      var s = document.querySelector(a.getAttribute('href'));
      if (s && s.getBoundingClientRect().top < 180) active = s.id;
    });
    navLinks.forEach(function (a) { a.setAttribute('aria-current', String(a.hash === '#' + active)); });
    ticking = false;
  }
  window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(updateNav); ticking = true; } }, { passive: true });
  updateNav();

  var disclosures = $$('.section-disclosure');
  var allButton = byId('toggle-sections');
  function updateAllButton() {
    if (!allButton) return;
    var allOpen = disclosures.every(function (d) { return d.open; });
    allButton.replaceChildren(document.createTextNode(allOpen ? 'Collapse all sections ' : 'Expand all sections '));
    var sym = el('span', null, allOpen ? '−' : '+');
    sym.setAttribute('aria-hidden', 'true');
    allButton.append(sym);
    allButton.setAttribute('aria-label', allOpen ? 'Collapse all listing sections' : 'Expand all listing sections');
    updateNav();
  }
  if (allButton) {
    allButton.hidden = false;
    allButton.setAttribute('aria-controls', disclosures.map(function (d) { return d.id; }).join(' '));
    allButton.addEventListener('click', function () {
      var expand = disclosures.some(function (d) { return !d.open; });
      disclosures.forEach(function (d) { d.open = expand; });
      updateAllButton();
      signal(expand ? 'expand_all' : 'collapse_all', {});
    });
  }
  disclosures.forEach(function (d) {
    d.addEventListener('toggle', updateAllButton);
    var summary = d.querySelector(':scope > summary');
    if (summary) summary.addEventListener('click', function () {
      if (d.open || !matchMedia('(max-width: 800px)').matches) return;
      requestAnimationFrame(function () {
        if (d.open) d.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    });
  });

  function reveal(hash) {
    var id;
    try { id = decodeURIComponent(String(hash || '').slice(1)); } catch (e) { return null; }
    if (!id) return null;
    var target = document.getElementById(id);
    if (!target || !root.contains(target)) return null;
    for (var n = target; n && n !== root; n = n.parentElement) if (n.tagName === 'DETAILS') n.open = true;
    if (target.classList.contains('ll-section')) {
      var d = target.querySelector(':scope > .section-disclosure');
      if (d) d.open = true;
    }
    updateAllButton();
    return target;
  }
  root.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var t = reveal(a.hash);
    if (t) { e.preventDefault(); history.replaceState(null, '', a.hash); t.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
  });
  window.addEventListener('hashchange', function () {
    var t = reveal(location.hash);
    if (t) requestAnimationFrame(function () { t.scrollIntoView({ block: 'start' }); });
  });
  updateAllButton();
  if (location.hash) {
    var initial = reveal(location.hash);
    if (initial) requestAnimationFrame(function () { initial.scrollIntoView({ block: 'start', behavior: 'instant' }); });
  }

  /* Team carousel: arrow buttons scroll one card; arrows disable at the ends */
  Array.prototype.forEach.call(root.querySelectorAll('[data-carousel]'), function (c) {
    var track = c.querySelector('[data-carousel-track]');
    var prev = c.querySelector('[data-carousel-prev]');
    var next = c.querySelector('[data-carousel-next]');
    if (!track || !prev || !next) return;
    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
      var nav = c.querySelector('.team-arrows');
      if (nav) nav.hidden = max <= 0;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();


